export default [
    {
        path: "/company",
        // name: "company",
        component: () => import("@/views/amg/company/CompanyComponent.vue"),
        meta: {
            layout: "full",
            //pageTitle: 'Settings',
            // breadcrumb: [
            //     {
            //         text: "Settings",
            //         active: true
            //     }
            // ]
        },
        children: [
            {
                path: "select",
                component: () =>
                    import("@/views/amg/company/modules/SelectCompanyComponent.vue"),
                name: "company-init",
                meta: {
                    layout: "full",
                    // pageTitle: "Lista de torneos",
                    // breadcrumb: [
                    //     {
                    //         text: "Torneos",
                    //         active: true
                    //     }
                    // ]
                }
            }
        ]
    }
];
